import { Trans, t } from '@lingui/macro';
import PropTypes from 'prop-types';

import {
  competitiveCumulatedVolumeHelpMessage,
  differentialSentimentHelpMessage,
} from 'components/customer/v2/helpMessageV2';
import { NormalSpacePaddedRow } from 'components/ui/Grid';

import { getSentimentKpiColor } from 'utils/colors';
import {
  floatFormatter,
  numberFormatter,
  onePrecisionFloatFormatter,
} from 'utils/formatter';

import * as svars from 'assets/style/variables';

import DashboardKpi from '../dashboard/DashboardKpi';

function BenchmarkHeader({
  differentialSentiment,
  differentialSentimentIncrease,
  comparativeGroupsNChunks,
  comparativeGroupsNChunksIncrease,
  isLoading,
}) {
  return (
    <NormalSpacePaddedRow>
      <div style={{ display: 'inline-flex' }}>
        <DashboardKpi
          headerTextId={t({ id: 'competitors-volume' })}
          value={comparativeGroupsNChunks}
          increase={comparativeGroupsNChunksIncrease}
          color={svars.volumeColor}
          formatter={numberFormatter}
          increaseFormatter={onePrecisionFloatFormatter}
          description={<Trans id={competitiveCumulatedVolumeHelpMessage} />}
          articleId={23}
          loading={isLoading}
        />
        <DashboardKpi
          headerTextId={t({ id: 'differential-sentiment' })}
          value={differentialSentiment}
          increase={differentialSentimentIncrease}
          color={getSentimentKpiColor}
          formatter={floatFormatter}
          increaseFormatter={floatFormatter}
          description={<Trans id={differentialSentimentHelpMessage} />}
          articleId={71}
          loading={isLoading}
        />
      </div>
    </NormalSpacePaddedRow>
  );
}

const stringOrNumber = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
]);

BenchmarkHeader.propTypes = {
  differentialSentiment: stringOrNumber.isRequired,
  differentialSentimentIncrease: stringOrNumber.isRequired,
  comparativeGroupsNChunks: stringOrNumber.isRequired,
  comparativeGroupsNChunksIncrease: stringOrNumber.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default BenchmarkHeader;
